/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Release_Intro_Chip_New_For_MeInputs */



/**
* | output |
* | --- |
* | "What's new for me?" |
*
* @param {Uno_Release_Intro_Chip_New_For_MeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_release_intro_chip_new_for_me = /** @type {((inputs?: Uno_Release_Intro_Chip_New_For_MeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Release_Intro_Chip_New_For_MeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was ist neu für mich?")
	return /** @type {LocalizedString} */ ("What's new for me?")
});